import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { Auth } from 'src/app/models/auth';
import { Pedido } from 'src/app/models/pedido';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { Router } from '@angular/router';
import { PedidoConverter } from 'src/app/shared/helpers/converters/pedido-converter';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Purchase, PurchaseSummary } from 'src/app/models/purchase';
import { PurchaseConverter } from 'src/app/shared/helpers/converters/purchase-converter';

@Component({
  selector: 'app-ultimos-pedidos',
  templateUrl: './ultimos-pedidos.component.html',
  styleUrls: ['./ultimos-pedidos.component.css']
})
export class UltimosPedidosComponent implements OnInit {

  private currentUser: Auth;
  public pedidoList: PurchaseSummary[] = [];
  public compraList: PurchaseSummary[] = [];
  public SituacaoCompra = SituacaoCompra;
  constructor(
    private authenticationService: AuthenticationService,
    private pedidoService: PedidoService,
    private alertService: NewAlertService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private pedidoDataService: PedidoDataService) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.loadList();
  }

  loadList() {
    this.pedidoService.getLastPurchases([
      //this.SituacaoCompra.EmCriacao,
      this.SituacaoCompra.Criado,
      this.SituacaoCompra.ProcessamentoIniciado,
      this.SituacaoCompra.ParcialmenteProcessado,
      this.SituacaoCompra.ProcessadoComSucesso,
      this.SituacaoCompra.NaoProcessado,
      //this.SituacaoCompra.Cancelado
    ], 3, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.compraList = response.result;
          this.compraList = this.compraList.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
    /*
    this.pedidoService.getLastRequests([
      //this.SituacaoCompra.EmCriacao,
      this.SituacaoCompra.Criado,
      this.SituacaoCompra.ProcessamentoIniciado,
      this.SituacaoCompra.ParcialmenteProcessado,
      this.SituacaoCompra.ProcessadoComSucesso,
      this.SituacaoCompra.NaoProcessado,
      //this.SituacaoCompra.Cancelado
    ], 3, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.pedidoList = response.result;
          this.pedidoList = this.pedidoList.sort((a, b) => new Date(b.createDate).getTime() - new Date(a.createDate).getTime());
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
    */
  }

  novaCompra() {
    this.router.navigate([`portal/novarecarga/create`]);
  }

  details(purchase: PurchaseSummary) {
    this.router.navigate([`portal/minhasrecargas/details/${purchase.purchaseId}`]);
  }

  pedidosList() {
    this.router.navigate([`portal/minhasrecargas`]);
  }

  continuar(purchase: PurchaseSummary) {
    if (purchase.situationId === SituacaoCompra.EmCriacao) {
      this.pedidoService.getPurchaseById(purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToPurchase(response.result));
                this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
            } else {
                this.alertService.error(response.message);
            }
        }, error => { this.alertService.error(error.error); }
      );
    } else {
      this.alertService.error('Situação inválida para continuar a recarga');
    }
  }

  copiar(purchase: PurchaseSummary) {
    if (purchase.situationId !== SituacaoCompra.EmCriacao) {
      this.pedidoService.getPurchaseById(purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToNewPurchase(response.result));
                this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
            } else {
                this.alertService.error(response.message);
            }
        }, error => { this.alertService.error(error.error); }
      );
    } else {
      this.alertService.error('Situação inválida para copiar a recarga');
    }
  }

  statusLabel(purchase: PurchaseSummary) {
    switch (purchase.situationId) {
      case SituacaoCompra.ProcessadoComSucesso:
        return 'Concluído';
      case SituacaoCompra.Cancelado:
        return 'Cancelado';
      case SituacaoCompra.ParcialmenteProcessado:
        return 'Processado Parcialmente';
      case SituacaoCompra.NaoProcessado:
        return 'Não Processado';
      default:
        return 'Aguardando Processamento';
    }
  }

  statusColor(purchase: PurchaseSummary) {
    switch (purchase.situationId) {
      case SituacaoCompra.ProcessadoComSucesso:
        return this.sanitizer.bypassSecurityTrustStyle('#00C500');
      case SituacaoCompra.Cancelado:
        return this.sanitizer.bypassSecurityTrustStyle('#F1788A');
      case SituacaoCompra.ParcialmenteProcessado:
        return this.sanitizer.bypassSecurityTrustStyle('#FFC400');
      case SituacaoCompra.NaoProcessado:
        return this.sanitizer.bypassSecurityTrustStyle('#F1788A');
      default:
        return this.sanitizer.bypassSecurityTrustStyle('#F1788A');
    }
  }


  statusIcon(purchase: PurchaseSummary) {
    switch (purchase.situationId) {
      case SituacaoCompra.ProcessadoComSucesso:
        return this.sanitizer.bypassSecurityTrustUrl('./assets/icons/ultimos-pedidos/concluido.svg');
      case SituacaoCompra.Cancelado:
        return this.sanitizer.bypassSecurityTrustUrl('./assets/icons/ultimos-pedidos/alerta-vermelho.svg');
      case SituacaoCompra.ParcialmenteProcessado:
        return this.sanitizer.bypassSecurityTrustUrl('./assets/icons/ultimos-pedidos/alerta-amarelo.svg');
      case SituacaoCompra.NaoProcessado:
        return this.sanitizer.bypassSecurityTrustUrl('./assets/icons/ultimos-pedidos/alerta-vermelho.svg');
      default:
        return this.sanitizer.bypassSecurityTrustUrl('./assets/icons/ultimos-pedidos/aguardando.svg');
    }
  }

  labelBotao(purchase: PurchaseSummary) {
    if (purchase.situationId === SituacaoCompra.ProcessadoComSucesso ||
      purchase.situationId === SituacaoCompra.EmCriacao) {
      return 'Copiar';
    } else if (purchase.situationId === SituacaoCompra.ParcialmenteProcessado ||
       purchase.situationId === SituacaoCompra.NaoProcessado) {
        return 'Reprocessar';
    }
    return;
  }

  acaoBotao(purchase: PurchaseSummary) {
    if (purchase.situationId === SituacaoCompra.ProcessadoComSucesso ||
      purchase.situationId === SituacaoCompra.EmCriacao) {
      //PedidoConverter.pedidoToNewPedidoCadastro(purchase);
      this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
    } else if (purchase.situationId === SituacaoCompra.ParcialmenteProcessado ||
      purchase.situationId === SituacaoCompra.NaoProcessado) {
        this.reprocessar(purchase);
    }
    return;
  }

  reprocessar(purchase: PurchaseSummary) {
    this.pedidoService.reprocessar(purchase.purchaseId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success(response.message);
          this.loadList();
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!'); }
    );
  }
}
